import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, GoogleButton } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start finding jobs you can realistically apply for."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-slate-900 underline">Sign in</Link><br /><span className="text-slate-400">Hiring? </span><Link to="/register-business" className="font-semibold text-slate-900 underline" data-testid="link-business-signup">Create a business account</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="name">Full name</Label>
          <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
            data-testid="register-name-input" className="mt-1.5" placeholder="Your name" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email-input" className="mt-1.5" placeholder="you@example.com" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password-input" className="mt-1.5" placeholder="At least 8 characters" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-slate-900 hover:bg-slate-800">
          {loading ? "Creating…" : "Create account"}
        </Button>
        <p className="text-xs text-slate-500 leading-relaxed" data-testid="register-legal-note">
          By creating an account you agree to the <Link to="/terms" className="underline">Terms</Link>, the <Link to="/rules" className="underline" data-testid="register-rules-link">User Rules</Link> and acknowledge the <Link to="/privacy" className="underline">Privacy Policy</Link>.
        </p>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
        <div className="h-px flex-1 bg-slate-200" /> OR <div className="h-px flex-1 bg-slate-200" />
      </div>
      <GoogleButton label="Continue with Google" />
    </AuthShell>
  );
}
